import SingleClientReportTable from "./components/SingleClientReportTable";
import PageWrapper from "../../../components/Page/PageWrapper";
import SingleClientReportFilters from "./components/SingleClientReportFilters";
import PageTitle from "../../../components/Page/PageTitle";
import { useTranslation } from "react-i18next";

function SingleReports() {
  const { t } = useTranslation();

  return (
    <PageWrapper>
      <PageTitle title={t("pageHeaders.singleReports")} />
      <SingleClientReportFilters />
      <SingleClientReportTable />
    </PageWrapper>
  );
}

export default SingleReports;
